module.exports = __webpack_public_path__ + "img/lock.02c2ec81.svg";